/**
 * Stories-and-use-cases template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import el from './lib/elements';
import evt from './lib/events';
import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Stories-and-use-cases';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();


const filters    = el.id('filters');
const filters_select = el.id('filters-select');
/**
 * init --- Initialize the view
 */
function init() {
	// Logger.log(NAME + ' > init');
	addHandlers();
}

/**
 * addHandlers --- Add event handlers for view
 */
function addHandlers() {
	// Logger.log(NAME + ' > addHandlers');
	evt.add(filters, 'input', onFilter, true);
}

/**
 * onFilter --- When the user selects a filter, this is triggered
 * @param evt
 */
function onFilter(evt){
	const target = evt.target;
	let type;
	// console.log(1, target.nodeName);
	if (target && target.nodeName === "SELECT") {
		// console.log(target.value);
		window.location = target.value;
	}
}

init();


// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
